
import React, { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { energyDistribution } from '@/data/energy-analytics-data';
import { cn } from '@/lib/utils';

const COLORS = ['#10B981', '#3B82F6', '#F59E0B', '#EC4899', '#8B5CF6'];

const EnergyDistributionPieChart = () => {
  const [hiddenSectors, setHiddenSectors] = useState<string[]>([]);

  const handleLegendClick = (name: string) => {
    setHiddenSectors(prev => 
      prev.includes(name)
        ? prev.filter(item => item !== name)
        : [...prev, name]
    );
  };

  // Filter the data based on hidden sectors
  const visibleData = energyDistribution.filter(item => !hiddenSectors.includes(item.name));
  
  return (
    <AnimatedCard 
      animation="fade-up"
      delay={400}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Energy Distribution (%)</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Enhanced legend with all categories - positioned above the chart */}
        <div className="mb-4">
          <div className="flex flex-wrap justify-center gap-3">
            {energyDistribution.map((entry, index) => (
              <div 
                key={`legend-${index}`}
                className={cn(
                  "flex items-center gap-2 px-3 py-1.5 rounded-md cursor-pointer transition-all",
                  hiddenSectors.includes(entry.name)
                    ? "opacity-50 bg-gray-100 dark:bg-gray-700"
                    : "bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700"
                )}
                onClick={() => handleLegendClick(entry.name)}
              >
                <span 
                  className="inline-block w-3 h-3 rounded-full" 
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                />
                <span className="text-sm font-medium whitespace-nowrap">{entry.name}: {entry.value}%</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={visibleData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                nameKey="name"
                label={false}
                labelLine={false}
              >
                {visibleData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[energyDistribution.findIndex(item => item.name === entry.name) % COLORS.length]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default EnergyDistributionPieChart;
